<template>
  <div class="down">
    <div class="downloadbox">
        <img src="../assets/account/bg_HAI.png" v-if="domain == 'www.meetfic.com'"/>
        <img src="../assets/gemnovel/gem.png" v-if="domain == 'www.gemnovel.com'"/>
        <img src="../assets/wakenovel/wakenovel.png" v-if="domain == 'www.wakenovel.com'"/>
        <img src="../assets/adoread/adoread.png"  v-if="domain == 'fb.adoread.com'"/>
        <img src="../assets/inktale/ink.png" v-if="domain == 'fb.inktale.net'"/>
        <img src="../assets/novelshort/short.png" v-if="domain == 'fb.novelettebox.com'||domain == 'fb.lovenovelshort.com'||domain == 'fb.lovenovelshort.com'"/>
        <div class="center" v-if="domain == 'www.meetfic.com'">
            <a class="download-btn" href="https://play.google.com/store/apps/details?id=com.blackstone.reader"><img src="../assets/account/btn_android.png"/></a>
            <a class="download-btn" href="https://apps.apple.com/us/app/meetfic/id1615532334"><img src="../assets/account/btn_iphone.png"/></a>
        </div>
        <div class="center" v-if="domain == 'www.gemnovel.com'">
            <a class="download-btn" href="https://apps.apple.com/us/app/meetfic/id1615532334"><img src="../assets/gemnovel/btn_iphone_gem.png"/></a>
        </div>
        <div class="center" v-if="domain == 'www.wakenovel.com'">
            <a class="download-btn" target="_blank" href="https://play.google.com/store/apps/details?id=com.blackstone.reader"><img src="../assets/wakenovel/btn_Android.png"/></a>
            <a class="download-btn" target="_blank" href="https://apps.apple.com/us/app/meetfic/id1615532334"><img src="../assets/wakenovel/btn_iphone.png"/></a>
        </div>
        <div class="center" v-if="domain == 'fb.adoread.com'">
            <a class="download-btn" target="_blank" href="https://play.google.com/store/apps/details?id=com.adoread.book"><img src="../assets/adoread/btn_Google.png"/></a>
        </div>
        <div class="center center-ink" v-if="domain == 'fb.inktale.net'">
            <a class="download-btn" target="_blank" href="https://apps.apple.com/us/app/inktale/id6443915856"><img src="../assets/inktale/btn_ios.png"/></a>
        </div>
        <div class="center center-novelshort" v-if="domain == 'fb.novelettebox.com'||domain == 'fb.lovenovelshort.com'||domain == 'fb.lovenovelshort.com'">
            <a class="download-btn" target="_blank" href="https://play.google.com/store/apps/details?id=com.novelshort.book"><img src="../assets/novelshort/google.png"/></a>
            <a class="download-btn" target="_blank" href="https://apps.apple.com/app/id6502894256"><img src="../assets/novelshort/apple.png"/></a>
        </div>
    </div>
  </div>
</template>

<script>
    // import "utils/lib/rem1";
export default {
    data () {
        return {
            domain: 'www.wakenovel.com'
        }
    },
    mounted() {
        this.domain = window.location.host
        if (this.domain == 'www.wakenovel.com') {
          document.title = 'Wakenovel'
        } else if (this.domain == 'www.gemnovel.com') {
          document.title = "Gemnovel"
        } else if (this.domain == 'www.meetfic.com' || this.domain == 'meetfic.com') {
          document.title = "Meetfic"
        } else if (this.domain == 'fb.inktale.net' || this.domain == 'inktale.net') {
          document.title = "InkTale"
        } else if (this.domain == 'fb.adoread.com' || this.domain == 'adoread.com') {
            document.title = "Adoread"
        } else if (this.domain=='fb.novelettebox.com'||this.domain=='fb.lovenovelshort.com'||this.domain=='fb.lovenovelshort.com') {
            document.title = "NovelShort"
        }
    }
};
</script>

<style lang="scss" scoped>
.downloadbox{
    position: relative;
    img { width: 100%;}
    .center {
        position: absolute;
        top: 60%; //664px
        left: 10%;
        .download-btn {
            display: block;
            width: 310px;
            height: 78px;
            float: left;
            &:nth-child(1) {
                margin-right: 0.8rem;
            }
            img {
                width: 310px;
                height: 78px;
            }
        }
        &.center-ink{
            left: 16%;
        }
        &.center-novelshort{
            left: 45%;
        }
    }
}
</style>
